import { z } from "zod";

export const BranchToUserSchema = z.object({
	id: z.number(),
	A: z.number(),
	B: z.number(),
});

export type BranchToUserType = z.infer<typeof BranchToUserSchema>;
